import { render, staticRenderFns } from "./PartitionHelp.vue?vue&type=template&id=749f0ae1&"
import script from "./PartitionHelp.vue?vue&type=script&lang=js&"
export * from "./PartitionHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports